import { ReviewArtworkContextPanelGroup } from "./ReviewArtworkContextColumns";

interface CampaignReviewPaneProps {
  /** The review ticket to display (artwork + AI comments + context). */
  ticketId: string;
  /** Close the review screen and return to the default project view. */
  onClose: () => void;
}

/**
 * The project review screen: artwork in the center, with comments and
 * context/reference documents sharing the right column (comments top half,
 * context assets bottom half, or blank space when no context files exist).
 *
 * Selection state (active comment + citation highlight) mirrors
 * `TicketViewPane`, but the layout is intentionally different: the project
 * workspace keeps the feed/chat visible on the left, so this pane owns the
 * artwork viewer and the stacked comments + context column.
 */
export function CampaignReviewPane({
  ticketId,
  onClose,
}: CampaignReviewPaneProps) {
  return (
    <ReviewArtworkContextPanelGroup ticketId={ticketId} onClose={onClose} />
  );
}
